<template>
  <v-container fluid fill-height class="login-background">
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6" lg="4" align="center" justify="center">
        <v-card class="elevation-12">
          <v-toolbar dark color="primary">
            <v-toolbar-title>{{ $t("Login.Login") }}</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-form ref="form" v-model="valid">
              <v-text-field
                prepend-icon="mdi-account"
                name="login"
                :label="$t('Generic.Mail')"
                type="text"
                v-model="mail"
                :rules="[rules.required, rules.email]"
                v-on:keyup.enter="Login"
              ></v-text-field>
              <v-text-field
                prepend-icon="mdi-lock"
                name="password"
                :label="$t('Login.Password')"
                type="password"
                :rules="[v => !!v || $t('Rules.Password_required')]"
                v-model="password"
                v-on:keyup.enter="Login"
              ></v-text-field>
            </v-form>
            <v-checkbox
              v-model="rememberMail"
              :label="$t('Login.Remember_mail')"
              hide-details
            ></v-checkbox>
          </v-card-text>
          <v-card-actions>
            <v-btn v-on:click="RedirectForgotPassword" text>{{
              $t("Login.Forgot_password")
            }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              v-on:click="Login"
              :disabled="!valid"
              :loading="isLoggingIn"
              >{{ $t("Login.Login") }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import AuthService from "@/services/AuthenticationService";

export default {
  data() {
    return {
      rememberMail: false,
      valid: false,
      isLoggingIn: false,
      mail: "",
      password: "",
      rules: {
        required: value => !!value || this.$i18n.t("Rules.Mail_required"),
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || this.$i18n.t("Rules.Mail_invalid");
        }
      }
    };
  },
  methods: {
    RedirectForgotPassword() {
      this.$router.push({ name: "ForgotPassword" });
    },
    Login() {
      if (this.$refs.form.validate()) {
        this.isLoggingIn = true;
        var loginUser = {
          Mail: this.mail,
          Password: this.password
        };

        AuthService.Login(loginUser)
          .then(response =>
            this.$store.dispatch("PostSuccessLogin", {
              tokenUser: response.data,
              rememberUser: {
                KeepMail: this.rememberMail,
                Mail: this.mail
              }
            })
          )
          .catch(error =>
            this.$emit("show-error", this.$i18n.t("Error.Login_Failed"))
          )
          .finally(() => (this.isLoggingIn = false));
      }
    }
  },
  mounted() {
    this.mail = this.$store.getters.UserMail;

    this.rememberMail = this.mail && this.mail !== "";

    if (this.rememberMail) {
      this.$refs.password.focus();
    }
  }
};
</script>

<style scoped>
.login-background {
  background-image: url(../assets/login_background.jpg);
  background-size: cover;
}
</style>
